export class VideoHandler {
  constructor({ World, Emitter, Tick, Animate, PBRProgram, ogl }) {
    const _this = this;
    const gl = World.gl;

    this.match = {
      materialName: "MusicVideo"
      // meshName: 'Video',
      // meshName: 'ProjectionRocks2',
      // objectName: 'GroupCube',
      // groupName: 'links',
    };

    const { Texture, NormalProgram } = ogl;

    const videoTexture = new Texture(gl, {
      generateMipmaps: false,
      width: 1024,
      height: 512,
      flipY: false,
      wrapS: gl.REPEAT,
      wrapT: gl.REPEAT
    });

    const video = document.createElement("video");
    video.setAttribute("crossorigin", "anonymous");
    video.loop = true;
    video.autoplay = true;
    video.muted = true;
    video.playsInline = true;
    // document.body.appendChild(video);
    // Object.assign(video.style, {
    //     position: 'absolute',
    //     zIndex: 1,
    //     top: '0px',
    //     width: '100px',
    // });

    // Store nodes for when handling events
    const nodes = [];

    {
      handlers();
      Tick.on(update);
    }

    function update() {
      nodes.forEach(async node => {
        if (video.readyState >= video.HAVE_ENOUGH_DATA && !video.paused) {
          if (!videoTexture.image) {
            videoTexture.image = video;
            node.program.uniforms.tBaseColor.value = videoTexture;
          }
          videoTexture.needsUpdate = true;
        }
      });
    }

    function handlers() {
      Emitter.on("update-video", videoEvent);
    }

    function videoEvent({ video_url, progress = 0, timestamp = Date.now() }) {
      // console.log(track, progress, Date.now() - timestamp);

      // video.src = 'https://file-examples-com.github.io/uploads/2017/04/file_example_MP4_1280_10MG.mp4';
      if (video_url) {
        video.src = video_url;
        video.play();
      }

      // const delay = Date.now() - timestamp / 1000;

      video.currentTime = progress;
    }

    this.add = node => {
      // console.log(node.program);
      const gltfMaterial = Object.assign({}, node.program.gltfMaterial);
      gltfMaterial.baseColorTexture = {
        index: gltfMaterial.baseColorTexture.index,
        texture: videoTexture
      };
      gltfMaterial.emissiveTexture = null;
      gltfMaterial.doubleSided = false;
      gltfMaterial.skipFog = true;
      node.program = { gltfMaterial };

      // console.log(node.program);
      const program = PBRProgram.parseGLTF(node);
      program.setBlendFunc(gl.SRC_ALPHA, gl.DST_ALPHA);
      node.program = program;
      nodes.push(node);

      // node.visible = false;

      // if (!group.children.length) return;
      // group.children.forEach((node) => {
      //     if (!node.name || !DATA[node.name]) return;
      //     node.traverse((child) => {
      //         if (!child.program) return;
      //         // Replace program
      //         const program = PBRProgram.parseGLTF(
      //             child,
      //             [
      //                 {
      //                     match: `// UNIFORMS`,
      //                     replacement: `uniform float uStoreActive;`,
      //                 },
      //                 {
      //                     match: `// FINAL COLOR`,
      //                     replacement: `color = mix(color, vec3(0.5, 0.5, 1.0), uStoreActive);`,
      //                 },
      //             ],
      //             {
      //                 uStoreActive: { value: 0 },
      //             }
      //         );
      //         child.program = program;
      //     });
      //     nodes.push(node);
      // });
    };

    this.fallback = () => {
      // console.log('Stone1Handler not used');
    };

    this.destroy = () => {
      //
    };
  }
}
